<!--
 * @Author: cgh
 * @Date: 2022-09-23
 * @LastEditors: zxf
 * @LastEditTime: 2023-05-12 18:51:20
 * @Description: 成员信息添加、修改窗口
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="添加"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
        :validate-on-rule-change="false"
      >
        <el-row class="c-form__row">
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="姓名"
              prop="userVO.userName"
            >
              <el-input
                v-model.trim="fd.userVO.userName"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="联系电话"
              prop="userVO.tel"
            >
              <el-input
                v-model.trim="fd.userVO.tel"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <!-- <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="有效标志"
              prop="userVO.valid"
            >
              <el-radio-group
                v-model="fd.userVO.valid"
                class="c-form__radio-group"
              >
                <el-radio label="Y">
                  有效
                </el-radio>
                <el-radio label="N">
                  无效
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="邮箱"
              prop="userVO.email"
            >
              <el-input
                v-model.trim="fd.userVO.email"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col> -->
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="角色"
              prop="roleList"
            >
              <el-select
                v-model="fd.roleList"
                clearable
                value-key="value"
                placeholder="请选择角色"
                multiple
              >
                <el-option
                  v-for="item in roleList"
                  :key="item.deptRoleUuid"
                  :label="item.roleName"
                  :value="item.deptRoleUuid"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            v-for="(attrUserItem, index) in attrUserList"
            :key="'attrUser'+ index"
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              :label="attrUserItem.attrName"
              :prop="'userVO.attrs.' + attrUserItem.attrKey"
            >
              <template v-if="attrUserItem.enums">
                <template v-if="enums[attrUserItem.enums] && Object.keys(enums[attrUserItem.enums]).length <= 2">
                  <el-radio-group
                    v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__radio-group"
                  >
                    <el-radio
                      v-for="value in enums[attrUserItem.enums]"
                      :key="value.id"
                      :label="value.id"
                    >
                      {{ value.text }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-else>
                  <el-select
                    v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__select"
                    style="width: 100%;"
                    placeholder=""
                    clearable
                  >
                    <el-option
                      v-for="(value) in enums[attrUserItem.enums]"
                      :key="value.id"
                      :label="value.text"
                      :value="value.id"
                    />
                  </el-select>
                </template>
              </template>
              <template v-else-if="attrUserItem.attrType === 'String' || attrUserItem.attrType === 'Double'">
                <el-input
                  v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                  class="c-form__input"
                  placeholder=""
                />
              </template>
              <template v-else-if="attrUserItem.attrType === 'Date'">
                <el-date-picker
                  v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </template>
              <template v-else-if="attrUserItem.attrType === 'Image'">
                <image-upload
                  ref="files"
                  v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="image/*"
                  :data="uploadFd"
                  list-type="picture-card"
                >
                  <i
                    slot="default"
                    class="el-icon-plus"
                  />
                </image-upload>
              </template>
            </el-form-item>
          </el-col>
          <!-- <el-col
            v-if="!editCapacityVo"
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="登录密码"
              prop="userAuthVO.pwd"
            >
              <el-input
                v-model.trim="fd.userAuthVO.pwd"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button @click="closeDialog()">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { userService, roleCapacityService } from './user.service';

import AddUser from '@/features/system/attr/user/addUser.vue';
// 继承于新增用户
export default {
  name: 'AddDialog',
  extends: AddUser,
  data () {
    return {
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'zjz',
            value: null
          }
        ]
      },
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      /* 表单参数 Start */

      disabled: false,
      showDialogName: null,

      roleList: [], // 岗位列表
      roleFilter: {
        userCode: null,
        deptCode: null
      }
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    handleSave () {
      this.fd.userVO.userCode = this.fd.userVO.tel;
      this.fd.userAuthVO.account = this.fd.userVO.tel;
      this.fd.userVO.attrs.SFZZH = this.fd.userVO.attrs.SFZZH || 'N';
      this.fd.capacityVO.capacityCode = this.fd.userVO.tel;
      this.fd.userVO.attrs.ZGZSZP = this.fd.userVO.attrs.ZGZSZP instanceof Array ? '' : this.fd.userVO.attrs.ZGZSZP;
      this.fd.userVO.attrs.ZJZP = this.fd.userVO.attrs.ZJZP instanceof Array ? '' : this.fd.userVO.attrs.ZJZP;
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 如果是新增用户，调用新增用户接口
          if (!this.editCapacityVo) {
            // 单身份的身份名称使用用户名称值替代 start
            this.fd.capacityVO.capacityName = this.fd.userVO.userName;
            this.fd.userAuthVO.pwd = this.$config.initPwd;
            this.fd.capacityVO.deptCode = this.roleFilter.deptCode;
            // 单身份的身份名称使用用户名称值替代 end
            userService.save(this.fd)
              .then(rsp => {
                this.handleSaveRole();
              })
              .catch(err => {
                console.error('用户新增出错！', err);
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            // 单身份不会创建新身份
            this.$alert('用户已存在！', '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              callback: action => {
              }
            });
            this.loading = false;
          }
        }
      });
    },
    /**
     * @description: 查询所有可关联岗位列表
     * @param {*}
     * @return {*}
     */
    getRoleList () {
      this.loading = true;
      roleCapacityService.getWglRoleList(this.roleFilter.userCode, this.roleFilter.deptCode)
        .then(rsp => {
          this.roleList = rsp.data.list.filter((item) => {
            return item.roleCode !== 'projectsManage';
          });
        })
        .catch(err => {
          console.error('查询岗位错误', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 岗位关联保存操作
     * @param {*}
     * @return {*}
     */
    handleSaveRole () {
      this.loading = true;
      roleCapacityService.save({
        capacityCode: this.fd.userVO.userCode, // 用户身份uuid
        deptRoleUuid: this.fd.roleList // 已关联岗位uuid
      })
        .then(rsp => {
          this.$alert('新增成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.log('岗位关联保存错误', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }

  },
  created () {
    this.$set(this.fd, 'roleList', []);
    const currentUser = this.$HMStoreService.getUserinfo();
    this.roleFilter.userCode = currentUser.capacity.capacityCode;
    this.roleFilter.deptCode = currentUser.capacity.deptCode;
    this.getRoleList();
  }
};
</script>
